import React from 'react';
import Loading from './Loading';
import Table from './Table';

const RecentTraffic = ({entries}) => {
  if (entries === null) return <Loading />;

  return (
    <div style={{width: 'calc(100% - 40px)',
                 overflowY: 'auto',
                 padding: '20px',
                 display: 'flex',
                 flexDirection: 'column',
                 gap: '20px',
                }}>
      <Table headers={['Date', 'Time', 'Domain']}
             contents={entries.map(({ date, time, domain }) => {
               return [date, time, domain];
             })}
             proportions={[1, 1, 1]} />
    </div>
  );
}

export default RecentTraffic;
